var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-swipe',{attrs:{"autoplay":3000,"indicator-color":"white"}},_vm._l((_vm.item.picList),function(picItem,index){return _c('van-swipe-item',{key:picItem.url+index},[_c('van-image',{attrs:{"src":picItem.url}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }